import { Base } from "./base";
import { getAccessToken } from "../utils/browserStorage";

export class ChatAssistant extends Base {
  /**
   * @description List Location API function
   * @returns {Promise<Response>}
   */
  

  list(query) {
    let queryParam = new URLSearchParams(query).toString();
    const url = this._getFullURL("/ai/chat-assistant?" + queryParam);
    return this._secureFetch(url);
  }



  create(formData) {
    const url = this._getFullURL("/ai/chat-assistant");
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${getAccessToken()}`);


    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formData,
      redirect: "follow",
    };
    return fetch(url, requestOptions);
  }
  uploadFile(formData) {
    const url = this._getFullURL("/ai/chat-assistant/files");
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${getAccessToken()}`);


    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formData,
      redirect: "follow",
    };
    return fetch(url, requestOptions);
  }

  markMessageFeedback(messageId, feedback, reason = null) {  
    const url = this._getFullURL("/ai/chat-assistant/feedback");
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${getAccessToken()}`);

    const formData = new FormData();
    formData.append("messageId", messageId);
    formData.append("feedback", feedback);
    if (reason) {
      formData.append("reason", reason);
    }

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formData,
      redirect: "follow",
    };
    return fetch(url, requestOptions);
  }
}
